module.exports = __webpack_public_path__ + "static/media/icons.06400145.ttf";